import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Hero from './components/Hero';
import HeroFilm from './components/HeroFilm';
import HowItWorks from './components/HowItWorks';
import Features from './components/Features';
import Screens from './components/Screens';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import ChangelogPage from './pages/ChangelogPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import SubprocessorsPage from './pages/SubprocessorsPage';
import VertraeglichPage from './pages/VertraeglichPage';
import './App.css';

// Single dark theme - the site deliberately matches the app's #000 theme
// colour (design handoff), so the old light/dark toggle is gone.
function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Hero />
                  <HeroFilm />
                  <HowItWorks />
                  <Features />
                  <Screens />
                  <Pricing />
                  <FAQ />
                  <CTA />
                </>
              }
            />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/changelog" element={<ChangelogPage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            {/* The privacy policy links here rather than naming vendors inline. */}
            <Route path="/subprocessors" element={<SubprocessorsPage />} />
            {/* A demand test, reachable by URL only (docs/plans/PIVOT_RESEARCH.md). */}
            <Route path="/vertraeglich" element={<VertraeglichPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
